import React from 'react';
import PropTypes from 'prop-types';

/**
 * Title
 *  - Main title for the step
 */
export function Title(props) {
  return (
    <p className={props.className}>
      {props.text}
    </p>
  );
}

Title.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Text to display on Title
   */
  text: PropTypes.string,
};

Title.defaultProps = {
  className: '',
  text: '',
  number: 0,
};
